module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/KN-9f4afe2e60103ef51b47f0d4d76a9f9c.png";